import React, { useMemo } from 'react';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import TypeSlide from '../../components/type_slider/type_slide';
import { onTypeformClick, onKakaoClick } from '../../common/sendLog';

import styles from './page_banner.module.css';

const contents = {
  solution: {
    pos: '더 이상 포스를 두 대로 나누지 마세요,\r\n 터치 한번으로 바뀌는 결제 / 주방 프로그램',
    kiosk: '키오스크로 주문부터 매장관리까지\r\n 유기적으로 연동되는 솔루션',
    ukiki: '별도의 태블릿 필요없이\r\n포인트 적립과 모바일 오더를 한번에',
    management: '웹과 모바일로 언제든지 확인 가능한\r\n매장 관리 프로그램',
  },
  hardware:
    '윈도우 기반의 우노스 솔루션을 적용한\r\n다양한 하드웨어를 만나보세요.',
  case: {
    catering: '주문, 결제, 매장관리를\r\n한번에 해결하기',
    spicy_hot_pot: '저울과 연동되는 키오스크\r\n편리한 주문, 편리한 운영',
    unmanned: '바코드를 이용한\r\n24시간 완전 무인 매장',
  },
};

const PageBanner = ({ type }) => {
  const getStepName = (menu, subMenu) => {
    let name =
      menu === 'solution'
        ? '솔루션 소개'
        : menu === 'hardware'
        ? '제품 소개'
        : '다양한 업종';

    let subName = '';
    switch (subMenu) {
      case 'kiosk':
        subName = '키오스크';
        break;

      case 'pos':
        subName = '포스';
        break;

      case 'management':
        subName = '매장관리';
        break;

      case 'ukiki':
        subName = '우키키';
        break;

      case 'catering':
        subName = '요식업';
        break;

      case 'spicy_hot_pot':
        subName = '마라탕';
        break;

      case 'unmanned':
        subName = '무인매장';
        break;

      case 'others':
        subName = '담배 자판기';
        break;

      default:
        break;
    }
    return `${name} - ${subName}`;
  };

  const steps = type && type.split('/');
  const step = steps ? getStepName(steps[1], steps[2]) : '';

  const title = useMemo(() => {
    if (steps) {
      if (steps[1] === 'hardware') {
        return contents[steps[1]];
      }
      return contents[steps[1]][steps[2]];
    }

    return '';
  }, [steps]);

  return (
    <div className={styles.container}>
      <div className={styles.bannerContainer}>
        <LazyLoadImage
          alt=''
          width='auto'
          height='100%'
          src={
            process.env.PUBLIC_URL +
            `/imgs${
              type && type.includes('hardware') ? '/hardware/hardware' : type
            }_bn.png`
          }
          /* placeholderSrc={
          process.env.PUBLIC_URL + fileName + '_holder.' + extension
        } */
        />

        <div className={styles.wrapper}>
          <div className={styles.contents}>
            <span>{step}</span>
            <h2>{title}</h2>

            <div className={styles.askBtns}>
              {/* <div
                onClick={() => onTypeformClick(steps ? steps[1] : '')}
                className={styles.onlineBtn}
              >
                <TypeSlide>온라인 상담 신청</TypeSlide>
              </div> */}

              <div
                onClick={() => onKakaoClick(steps ? steps[1] : '')}
                className={styles.kakaoBtn}
              >
                카카오톡 상담 신청
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
